<template>
  <v-simple-table
    :class="[
      isTransparent ? 'transparent' : 'background',
      hoverTable ? '' : 'no-hover-table',
    ]"
    dense
  >
    <tbody>
      <tr v-for="(key, index) in tableKeys" :key="key">
        <td class="caption  pa-0 font-weight-bold">
          <div class="d-flex align-start" style="height: 100%">
            {{ generateMessage(`${i18Path}.${key}`) }}
          </div>
        </td>

        <td
          class="caption pa-0 text-end"
          :class="index | setClass(specificClasses)"
          v-if="Array.isArray(item[key])"
        >
          <div v-for="(value, index) in item[key]" :key="index">
            <slot name="arrayItem" :item="value">
              {{ value }}
            </slot>
          </div>
        </td>
        <td
          class="caption pa-0 text-end"
          :class="index | setClass(specificClasses)"
          v-else
        >
          {{ format(key, index) }}
        </td>
      </tr>
    </tbody>
  </v-simple-table>
</template>
<script>
import { formatField } from '@/business/utils/display';
import { generateMessage } from '@/utils/i18n';

export default {
  name: 'custom-simple-table',
  props: {
    hoverTable: { type: Boolean, required: false, default: false },
    i18Path: { type: String, required: true },
    tableKeys: { type: Array, required: true },
    tableUnits: { type: [Array, String], required: false },
    specificClasses: { type: Array, required: false, default: () => [] },
    item: { type: Object, required: true },
    attributesObjRef: { type: Object, required: false },
    isTransparent: { type: Boolean, default: false },
  },
  filters: {
    setClass(index, table) {
      if (table.length < index) return '';
      return table[index];
    },
  },
  methods: {
    generateMessage,
    formatField,
    format(key, index) {
      if (this.item[key] === undefined && !key.includes('.')) return null;
      if (this.tableUnits) {
        if (Array.isArray(this.tableUnits)) {
          return this.$t(
            `message.boilerplate.units.${this.tableUnits[index]}`,
            {
              number: this.formatField(this.item, key, this.attributesObjRef),
            }
          );
        }
        return this.$t(`message.boilerplate.units.${this.tableUnits}`, {
          number: this.formatField(this.item, key, this.attributesObjRef),
        });
      }
      return this.formatField(this.item, key, this.attributesObjRef);
    },
  },
};
</script>

<style scoped>
.no-hover-table {
  pointer-events: none;
}
</style>
